import { clientV2 } from "shared/api/axios";
import { createURL } from "shared/api/utils";
import { EventTypeEnum } from "shared/types";

export type StaticTableIngestionType =
  EventTypeEnum.CLAIM | EventTypeEnum.SIGNAL_EVENT | EventTypeEnum.VEHICLE;

interface LatestIngestionBase {
  name: string;
  ingestedAt: string | null;
  windowWeeks: number;
}

interface NamedIngestion extends LatestIngestionBase {
  type: "dashboardView" | "dataSource";
  displayName: string;
}

interface StaticTableIngestion extends LatestIngestionBase {
  type: StaticTableIngestionType;
  displayName: null;
}

export type LatestIngestion = NamedIngestion | StaticTableIngestion;

export interface LatestIngestionView {
  title: string;
  eventType: EventTypeEnum.CLAIM | EventTypeEnum.SIGNAL_EVENT;
  filter: string;
  vehiclesFilter: string;
  windowWeeks?: number;
}

export interface LatestIngestionsRequest {
  skipRequest?: boolean;
}

export const getLatestIngestionsRequestURI = ({
  skipRequest,
}: LatestIngestionsRequest): string =>
  skipRequest
    ? ""
    : clientV2.getUri({
        method: "POST",
        url: createURL(["ingestion", "latest"]),
      });
